<!-- 数据看板 -->
<template>
  <div class="tab-box">
  </div>
</template>

<script>

  import QcContainer from "@/components/el/layout/qc-container.vue";
  import TimeBetween from "@/components/el/time-between.vue";
  import CardItem from "@view/index/card-item.vue";

  export default {
    name: "main",
    components: {CardItem, TimeBetween, QcContainer},
    data() {
      return {
        activeIndex:0,
        searchObj:{type:0,shopId:"",startTime:"",endTime:""},
        shopList:null,
        detail:null,
        eCharts:null,
      }
    },
    mixins: [tableBase],
    methods: {

    },
    mounted() {
    }
  }
</script>

<style lang="less" scoped>
.tab-box{
  margin-bottom: 20px;
  display: flex;
  background: #FFFFFF;
  height: 50px;
  align-items: center;
  .tab{
    width: 100px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    &.active,&:hover{
      color: @primary;
    }
  }
}
.time-box{
  width: 100%;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
}
.card-box-x{
  margin: 0 20px;
  display: flex;
}
.line-box{
  margin-top: 20px;
  height: 400px;
}
</style>
